import { MenuService } from './../../core/services/menu.service';
import { BillingType, UtilityType } from './../../shared/constants/enum';
import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import MetisMenu from 'metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

import { HttpClient } from '@angular/common/http';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { json } from 'stream/consumers';
import { LayoutService } from '../../core/services/layout.service';

@Component({
  selector: 'app-rp-sidebar',
  templateUrl: './rp-sidebar.component.html',
  styleUrl: './rp-sidebar.component.scss',
  standalone: false,
})
export class RpSidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef: any;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems: MenuItem[] = [];
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  currentUser: any;

  constructor(
    private sharedService: SharedService,
    private eventService: EventService,
    private router: Router,
    public translate: TranslateService,
    private http: HttpClient,
    private layoutService: LayoutService,
    private menuService: MenuService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this._activateMenuDropdown();
          this._scrollElement();
        }, 500);
      }
    });
  }

  roles: any;
  ngOnInit() {
    this.getUserInfo();
    this._scrollElement();
  }
  billingType: any;
  ConsumerType = BillingType;
  consumerMetrsMenu: any;
  isWalletEnabled: boolean = false;
  isMeterReadingMenuOnOff: boolean = false;
  isMenuCollapesed: boolean = false;
  isDisplayBillsInvoices: boolean = false;
  isTriSourceSettlement: boolean = false;
  ishasLeakDetector: boolean = false;
  activeInstance: boolean = false;
  isAiModuleEnabled: boolean = false;
  isRippleUnitRate: boolean = false;
  isEVUtilityEnabled: boolean = false;
  getUserInfo() {
    this.sharedService.getCurrentUser().subscribe((user) => {
      this.currentUser = user;
      this.roles = user.currentUserRoleDetails;
      this.billingType = user.project?.billingType;
      this.activeInstance = user?.activeInstance;
      console.log(this.activeInstance);
      //this.consumerMetrsMenu = user.project?.meterMenu;
      this.isWalletEnabled = user?.project?.isWalletEnabled;
      this.isDisplayBillsInvoices = user?.project?.isDisplayOldBills;
      this.isMeterReadingMenuOnOff = user?.project?.isMeterReadingMenuOnOff;
      this.isAiModuleEnabled = user?.project?.isAiModuleEnabled;
      this.isRippleUnitRate = !!(
        user?.project?.isRippleUnitRate ??
        user?.project?.IsRippleUnitRate ??
        false
      );
      this.isEVUtilityEnabled = this.hasSelectedUtility(UtilityType.EV);
      this.ishasLeakDetector = this.currentUser?.hasLeakDetector
      this.isTriSourceSettlement =
        user?.project?.triSourceBillingMethodology?.toLowerCase() ===
          'carry forward'
          ? true
          : false;

      //console.log(this.isTriSourceSettlement);
      this.initialize();
    });
  }

  private hasSelectedUtility(utilityName: string): boolean {
    const projectUtilities =
      this.currentUser?.projectUtilities ??
      this.currentUser?.project?.projectUtilities ??
      this.currentUser?.project?.ProjectUtilities ??
      this.currentUser?.project?.selectedUtilities ??
      this.currentUser?.project?.SelectedUtilities ??
      this.currentUser?.project?.utilities ??
      this.currentUser?.project?.Utilities ??
      [];

    return Array.isArray(projectUtilities)
      ? projectUtilities.some((utility: any) => {
          const name =
            utility?.name ??
            utility?.Name ??
            utility?.utilityName ??
            utility?.UtilityName ??
            utility?.master?.name ??
            utility?.Master?.Name ??
            utility;
          return (
            name?.toString().trim().toLowerCase() ===
            utilityName.trim().toLowerCase()
          );
        })
      : false;
  }
  ngAfterViewInit(): void {
    this.layoutService.isCollapsed$.subscribe((state) => {
      this.isMenuCollapesed =
        document.body.classList.contains('vertical-collpsed');
    });
  }

  toggleMenu(event: any) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName('mm-active').length > 0) {
        const currentPosition = document.getElementsByClassName(
          'mm-active'
        )[0] as HTMLElement;
        const sticky = currentPosition.offsetTop;

        if (sticky > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              sticky + 300;
      }
    }, 300);
  }
  toggleMobileMenu(event: any) {
    localStorage.removeItem('selectedTabIndex');
    // console.log('event', event);
    let filterState!: CompositeFilterDescriptor;
    this.sharedService.clearAllFilters();

    localStorage.removeItem('filter');
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }
  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: string) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    let links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths: string[] = [];
    for (let i = 0; i < links.length; i++) {
      // Assert the type of each element in the array as HTMLAnchorElement
      const anchorElement = links[i] as HTMLAnchorElement;
      paths.push(anchorElement.pathname);
    }
    // for (let i = 0; i < links.length; i++) {
    //   paths.push(links[i]['pathname']) ;
    // }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement?.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) {
              childAnchor.classList.add('mm-active');
            }
            if (childDropdown) {
              childDropdown.classList.add('mm-active');
            }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  }

  // Define functions for each role's filter criteria
  adminFilter(
    item: any,
    billingType: string,
    isWalletEnabled: boolean,
    isDisplayBillsInvoices: boolean,
    isTriSourceSettlement: boolean
  ): boolean {
    console.log(isTriSourceSettlement);

    switch (item.label) {
      case 'Bills':
      case 'Statements':
        return item.billType === billingType;

      case 'Old Bills':
        return item.isDisplayBillsInvoices == isDisplayBillsInvoices;
      case 'Wallet':
        return item.isWalletEnabled === isWalletEnabled;

      case 'Solar Settlement':
        return item.isTriSourceSettlement === isTriSourceSettlement;
      case 'EV Readings':
        return item.isEVUtilityEnabled === this.isEVUtilityEnabled;
      case 'AI Assistant': return item.isAiModuleEnabled === this.isAiModuleEnabled;
      /* case 'AI Assistant':
        if (this.activeInstance) {
          return false
        } else {
          return true
        } */
      /*  case 'Unit Rate History':
         if (item.billType === billingType) {
           return true
         } else {
           return false
         } */
      default:
        return true;
    }
  }

  consumerFilter(
    item: any,
    billingType: string,
    isWalletEnabled: boolean,
    consumerMetrsMenu: boolean,
    isMeterReadingMenuOnOff: boolean,
    isTriSourceSettlement: boolean,
    ishasLeakDetector: boolean,
    isAiModuleEnabled: boolean,
    isEVUtilityEnabled: boolean
  ): boolean {
    // console.log(item.label)
    //console.log(billingType)
    //   console.log(billingType === this.ConsumerType.PREPAID)
    //let isMetrsMenu = true //when isMetrsMenu is true then only show meter details,meter controls in cosumer madule .
    if (
      item.label === 'Old Bills' &&
      billingType === this.ConsumerType.PREPAID
    ) {
      item.label = 'Old Statements';
      return true;
    }

    switch (item.label) {
      case 'Wallet':
      case 'Wallet History':
      case 'Recharge History':
        return item.isWalletEnabled === isWalletEnabled;
      case 'Solar Settlement':
        return item.isTriSourceSettlement === isTriSourceSettlement;
      case 'EV Readings':
        return item.isEVUtilityEnabled === isEVUtilityEnabled;
      /* case 'Unit Rate History':
        if (item.isWalletEnabled === isWalletEnabled && item.billType === billingType) {
          return true
        } else {
          return false
        } */

      // case 'Meter Controlls':
      // return isMetrsMenu === consumerMetrsMenu;
      case 'Smart Leak Devices':
        return (item.ishasLeakDetector = this.ishasLeakDetector)
      case 'Meter Readings':
        return (this.isMeterReadingMenuOnOff = isMeterReadingMenuOnOff);
      case 'Meters':
      case 'Unpaid Bills':
      case 'Statements':
      case 'Bill History':
      case 'Consumption History':
        return item.billType === billingType;
      case 'AI Assistant': return item.isAiModuleEnabled === this.isAiModuleEnabled;
      default:
        return true;
    }
  }
  // Define a mapping of roles to filter functions
  roleFilterMap: { [role: string]: (item: any) => boolean } = {
    Admin: (item: any) =>
      this.adminFilter(
        item,
        this.billingType,
        this.isWalletEnabled,
        this.isDisplayBillsInvoices,
        this.isTriSourceSettlement
      ),

    Consumer: (item: any) =>
      this.consumerFilter(
        item,
        this.billingType,
        this.isWalletEnabled,
        this.consumerMetrsMenu,
        this.isMeterReadingMenuOnOff,
        this.isTriSourceSettlement,
        this.ishasLeakDetector,
        this.isAiModuleEnabled,
        this.isEVUtilityEnabled
      ),
    EvAdmin: (item: any) =>
      item.label === 'EV Readings' &&
      item.isEVUtilityEnabled === this.isEVUtilityEnabled,
  };
  initialize(): void {
    // Get the filter function for the current role
    let filterFunction = this.roleFilterMap[this.roles.role] || (() => true);

    // Filter menu items based on the role and conditions
    this.menuItems = this.filterMenuItemsByRole(this.roles.role).filter(
      filterFunction
    );

    // console.log(this.menuItems);
  }
  /**
   * Initialize
   */
  /*  initialize(): void {
     this.menuItems = this.filterMenuItemsByRole(this.roles.role).filter(
       (item: any) => {
         if (this.roles.role == 'Admin' && item.label == 'Bills') {
           return item.billType === this.billingType;
         }
         if (this.roles.role == 'Consumer' && item.label == 'Wallet') {
           return item.isWalletEnabled == this.isWalletEnabled;
         }
         if (this.roles.role == 'Consumer' && item.label == 'Bills') {
           return item.billType === this.billingType;
         }
         if (this.roles.role == 'Consumer' && item.label == 'Bill History') {
           return item.billType === this.billingType;
         }
         if(
           this.roles.role == 'Consumer' && item.label == 'Consumption History') {
           return item.billType === this.billingType;
         }
           if(this.roles.role == 'Consumer' && item.label == 'Consumption History') {
           return item.billType === this.billingType;
         }
 
         return true;
       }
     );
     console.log(this.menuItems);
   } */

  filterMenuItemsByRole(role: any): any[] {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    // if( this.currentUser?.project.isPowerBIEnabled){
    this.menuService.updateMenuForPowerBI(
      this.currentUser?.project?.isPowerBIEnabled
        ? this.currentUser?.project?.isPowerBIEnabled
        : false
    );
    // }
    return this.menuService
      .getMenu()
      .filter((item: any) => {
        if (item.roles.includes(role)) {
          return true;
        }
        const normalizedRole = role
          ? role.toString().toLowerCase().replace(/\s+/g, '')
          : '';
        const normalizedRoles = item.roles.map((r: any) =>
          r.toString().toLowerCase().replace(/\s+/g, '')
        );
        return normalizedRoles.includes(normalizedRole);
      });
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
